<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'魔法播播间'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

    <div :class="'home-page-bbj ios-' + iosDevice">
      <div :class="'header header-' + headerStatus">{{headMyCode | newHeadMyCode}}魔法播播间</div>
      <div v-if="playShow !== true" class="register-page">
        <div>
          <div class="top-title"></div>
          <div class="bottom-register">
            <div class="pic"><img src="https://download4.qcplay.com/h5-images/active/servitor/bbj/pic_img.png"></div>
            <div class="btn" @click="openBtn()"></div>
            <div class="info"><p>登录代表您同意<strong>《使魔计划》给您送出好礼</strong></p></div>
          </div>
        </div>
      </div>

      <div :class="'play-page play-page-' + playShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div v-show="playShow">
            <div :class="'top-content content-' + headerStatus">
              <div class="info-cont">
                <div class="icon-l" @click="setShow = true">
                  <i :class="'my-pic my-pic-' + roleNum"></i>
                  <dl>
                    <dt>{{headMyCode}}</dt>
                    <dd>9999万观看</dd>
                  </dl>
                </div>
                <div class="icon-r">
                  <div class="pic-all">
                    <i :class="'pic-' + item" v-for="(item, index) in picArr" :key="index"></i>
                  </div>
                  <div class="gz-num">9999万+</div>
                </div>
              </div>
              <div class="det-cont">
                <div class="det-btn" @click="ruleShow = true"></div>
                <div class="r-cont">
                  <div class="species">金币余额：{{user_data.species_num}}</div>
                  <div class="number">魔法卷轴：{{user_data.mf_number}}</div>
                </div>
              </div>
            </div>

            <div class="centcer-content">
              <div class="scroll">
                <div class="photosphere-1">
                  <div class="species">{{user_data.new_pecies_num}}</div>
                  <div class="xx">
                    <ul>
                      <li :class="'li-' + item.id" v-for="(item, index) in starList" :key="index"></li>
                    </ul>
                  </div>
                  <div class="btn" @click="openBuyBtn()"></div>
                </div>
                <div class="photosphere-2">
                  <div class="xx">
                    <ul>
                      <li :class="'li-' + item.id" v-for="(item, index) in starList" :key="index"></li>
                    </ul>
                  </div>
                  <div class="btn" @click="viewReward()"></div>
                </div>
                <div class="lightning lightning-1"></div>                
                <div class="lightning lightning-2"></div>
              </div>
              <div :class="'role-cont role-' + roleNum"><div></div></div>
            </div>

            <div class="bottom-content">
              <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutUp" :duration="{ enter: 1000 }">           
                <div class="add-room" v-show="intoRoomShow">{{headMyCode}} 加入了直播间</div> 
              </transition>          
              <div class="cover"></div>
              <div class="scroll-info">
                <vue-seamless-scroll 
                  :data="wechatInfoList"
                  :class-option="classOption"
                  class="scroll"
                >
                  <ul class="item">
                    <li v-for="(item, index) in wechatInfoList" :key="index">
                      <p>
                        <b>VIP</b>
                        <span class="name" v-text="item.title"></span>
                        <span>:</span>
                        <span class="describe" v-text="item.desc"></span>
                      </p>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
              <div class="nav">
                <a :class="'rw-btn rw-btn-'+ is_red" @click="viewTask()" href="javascript:;" title="任务"></a>
                <a @click="viewFriendsRoom()" href="javascript:;" title="搜索"></a>
                <a @click="viewShareRoom()" href="javascript:;" title="分享"></a>
                <a @click="viewRecords()" href="javascript:;" title="记录"></a>
                <a class="jl-btn" @click="qqGroups()" href="javascript:;" title="加QQ群"></a>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- 是否第一次进入的弹窗 -->
    <div class="first-popup popup_wrap" v-show="!firstShow" @click="tipspage()">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="first-box popup_wrap-box" v-show="!firstShow">
          <div :class="'tips tips-' + tipsNum"></div>
        </div>
      </transition>
      <div class="close-bg"></div>
    </div>

    <!-- 个人设置弹窗 -->
    <div class="set-popup popup_wrap" v-show="setShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="set-box popup_wrap-box" v-show="setShow">
          <div class="secret-order" v-show="secretOrderShow">
            <p><strong>密令: 星夜下舞动</strong> <span @click="onCopy('#clipboard-btn')" id="clipboard-btn" data-event="复制邀请链接"
            :data-clipboard-text="'星夜下舞动'">复制</span></p>
          </div>
          <div class="more-list">
            <ul>
              <li>
                <span class="name">电影级画质</span>
                <mt-switch @change="switchStatus(switchStatus1, 1, '没这种东西，别点了...', '电影级画质')" v-model="switchStatus1"></mt-switch>
              </li>
              <li>
                <span class="name">背景音乐</span>
                <mt-switch @change="switchStatus(switchStatus2, 2, '来不及做了，给你个密令吧', '背景音乐')" v-model="switchStatus2"></mt-switch>
              </li>
            </ul>
            <div class="qh-btn" @click="openLoginOS()">
              <a href="javascript:;"></a>
            </div>
          </div>
          <div class="user-info">
            <span class="span-l">{{userInfo.role_name}}</span>
            <span class="span-r">服务器:{{ userInfo.server_name }}</span>
          </div>
        </div>
      </transition>      
      <div class="close-bg" @click="setShow = false"></div>
    </div>

    <!-- 规则弹窗 -->
    <div class="rule-popup popup_wrap" v-show="ruleShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box" v-show="ruleShow"></div>
      </transition>
      <div class="close-bg" @click="ruleShow = false"></div>
    </div>

    <!-- 分享我的直播间 -->
    <div class="my-zbj-popup popup_wrap" v-show="myZbjShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="my-zbj-box popup_wrap-box" v-show="myZbjShow">
          <div class="code-box">
            <p>{{activeInfo.code}}</p>
            <span id="my-code2" class="room-number" @click="onCopyShare('#my-code2')" :data-clipboard-text='activeInfo.code'>复制房号</span>
          </div>
          <a class="btn" id="my-code" @click="onCopyShare('#my-code')" data-event="复制邀请链接"
            :data-clipboard-text="'《使魔计划》-老板们来我播播间看看啊~魔法卷的价格被我打到' + user_data.new_pecies_num +'金币了！！不信你点进来看看' + shareLinkHelp + shareCode" href="javascript:;"></a>
        </div>
      </transition>
      <div class="close-bg" @click="myZbjShow = false"></div>
    </div>

    <!-- 前往他人播播间 -->
    <div class="friends-zbj-popup popup_wrap" v-show="youZbjShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="friends-zbj-box popup_wrap-box" v-show="youZbjShow">
          <div class="code-box"><p><label for=""><input type="text" v-model="otherCode" placeholder="请输入好友的播播间"></label></p></div>
          <a class="btn" @click="findCode()" href="javascript:;"></a>
          <a class="qq-btn" @click="qqGroups()" href="javascript:;"></a>
        </div>
      </transition>
      <div class="close-bg" @click="youZbjShow = false"></div>
    </div>

    <!-- 交易记录 -->
    <div class="transaction-record-popup popup_wrap" v-show="transactionShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="transaction-box popup_wrap-box" v-show="transactionShow">
          <div v-if="recordList.length == 0" class="null-data"></div>
          <ul v-else>
            <li v-for="(item, index) in recordList" :key="index">
              <dl>
                <dt><h4>{{ item.remark }}</h4><p>{{ item.created_at }}</p></dt>
                <dd v-if="item.score > 0" :class="'dd-' + item.score">+ {{ item.score }}</dd>
                <dd v-if="item.score <= 0 && item.number > 0" class="dd-jz">+ {{ item.number }}</dd>
              </dl>
            </li>
          </ul>
        </div>
      </transition>
      <div class="close-bg" @click="transactionShow = false"></div>
    </div>

    <!-- 卷轴购买完成 -->
    <div class="purchase-completed-popup popup_wrap" v-show="purchaseShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="purchase-completed-box popup_wrap-box" v-show="purchaseShow">
          <div class="purchase-box"><p>恭喜您成功购买<strong> 魔法卷轴 * {{is_number}}</strong></p></div>
        </div>
      </transition>
      <div class="close-bg" @click="purchaseClose()"></div>
    </div>

    <!-- 卷轴购买弹窗 -->
    <div class="buy-popup popup_wrap" v-show="buyShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="buy-box popup_wrap-box" v-show="buyShow">
          <div class="product-info">
            <dl>
              <dt>
                <img src="https://download4.qcplay.com/h5-images/active/servitor/bbj/product_img.png">
              </dt>
              <dd>
                <h3><span>{{user_data.old_pecies_num}}金币</span><strong>立减{{user_data.old_pecies_num - user_data.new_pecies_num}}金币</strong></h3>
                <h4>惊爆价：<strong>{{user_data.new_pecies_num}}金币</strong></h4>
              </dd>
            </dl>
          </div>
          <div class="product-quantity">
            <dl>
              <dt>总价：{{is_number * user_data.new_pecies_num}}金币</dt>
              <dd>
                <div>
                  <span @click="reduce()">-</span>
                  <b>{{ is_number }}</b>
                  <span @click="add()">+</span>
                </div>
                <strong @click="maxCount()">Max</strong>
              </dd>
            </dl>
          </div>
          <div class="btn" @click="goBuy()"></div>
        </div>
      </transition>
      <div class="close-bg" @click="closeBuy()"></div>
    </div>

    <!-- 任务列表弹窗 -->
    <div class="task-popup popup_wrap" v-show="taskShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="task-box popup_wrap-box" v-show="taskShow">
          <ul >
            <li v-for="(item, index) in taskList" :key="index">
              <span>{{item.title}}, <b>金币+{{item.number}}</b></span>
              <strong v-if="!item.is_get" :class="'species-' + item.is_get + ' get-' + item._get" @click="taskReceive(item.task_id, item.title, item._get)">{{item._get | taskDesc}}</strong>
              <strong v-else :class="'species-' + item.is_get">已领取</strong>
            </li>
          </ul>
        </div>
      </transition>
      <div class="close-bg" @click="taskShow = false"></div>
    </div>

    <!-- 奖励弹窗 -->
    <div class="reward-popup popup_wrap" v-show="rewardShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="reward-box popup_wrap-box" v-show="rewardShow">          
          <div class="reward-query-btn" @click="rewardListShow = true"></div>
          <div class="reward-main">
            <div class="top">
              <div class="grade-box">
                <span>奖励等级{{level_info.level}}</span>                
                <strong v-if="up_level_number < 60">{{up_level_number}}/{{need_level_number}}</strong>
                <strong v-else>Max</strong>
              </div>
              <div :class="'progress-box progress-box-' + need_level_number"><div><span :style="'width:' + percentage + '%'"></span></div></div>
            </div>
            <div class="content">
              <div class="sm-reward-box">
                <div class="role-reward">
                  <div :class="'insure before-'+ reward_All[3].prop_id" @click="saveOrNot(2)"></div>
                  <div :class="'before-one before-'+ reward_All[0].prop_id">
                    <span>{{reward_All[0].title.name}}</span>
                  </div>
                </div>
                <div class="btn-box">
                  <a class="left-btn" href="javascript:;" @click="saveOrNot(1)"></a>
                  <a class="right-btn" v-if="level_info.number <= user_data.mf_number" href="javascript:;" @click="refreshRewards(1)">{{ level_info.number }}刷新</a>
                  <a class="right-btn grey-btn" v-else href="javascript:;">{{ level_info.number }}刷新</a>
                </div>
              </div>
              <div class="dj-reward-box">
                <div class="dj-box">
                  <div :class="'before-one before-'+ reward_All[1].prop_id"><span>{{reward_All[1].title.name}}</span></div>
                  <a v-if="level_info.number <= user_data.mf_number" href="javascript:;" @click="refreshRewards(2)">{{ level_info.number }}刷新</a>
                  <a class="grey-btn" v-else href="javascript:;">{{ level_info.number }}刷新</a>
                </div>
                <div class="dj-box">
                  <div :class="'before-one before-'+ reward_All[2].prop_id"><span>{{reward_All[2].title.name}}</span></div>
                  <a v-if="level_info.number <= user_data.mf_number" href="javascript:;" @click="refreshRewards(3)">{{ level_info.number }}刷新</a>
                  <a class="grey-btn" v-else href="javascript:;">{{ level_info.number }}刷新</a>
                </div>
              </div>
              <div :class="'btn-box btn-' + start_get_reward">
                <div v-if="is_get !== 1">
                  <a href="javascript:;" @click="confirmReward()"></a>
                  <p>（4月30日解锁）</p>
                </div>
                <div v-else>
                  <a class="btn-off" href="javascript:;"></a>
                  <p>&nbsp</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="rewardClose()"></div>
    </div>

    <!-- 奖励列表 -->
    <div class="reward-list-popup popup_wrap" v-show="rewardListShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="reward-list-box popup_wrap-box" v-show="rewardListShow">
          <ul>
            <li :class="'grade-' + item.drade" v-for="(item, index) in rewardGradeTab" :key="index" @click="rewardListGrade = item.drade"></li>
          </ul>      
          <div :class="'reward-grade reward-grade-' + rewardListGrade"></div>
        </div>
      </transition>
      <div class="close-bg" @click="rewardListShow = false"></div>
    </div>

    <!-- 奖励获取完成 -->
    <div class="reward-gain-popup popup_wrap" v-show="rewardGainShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="reward-gain-box popup_wrap-box" v-show="rewardGainShow">
          <dl class="reward-info">
            <dt :class="'before-' + prop_info.prop_id"></dt>
          </dl>
          <div class="purchase-box"><p>恭喜刷新出<span>{{prop_info.title}}</span></p></div>
        </div>
      </transition>
      <div class="close-bg" @click="rewardGainShow = false"></div>
    </div>

    <!-- 奖励领取确认 -->
    <div class="claim-confirmation-popup popup_wrap" v-show="confirmationShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="claim-confirmation-box popup_wrap-box" v-show="confirmationShow">
          <div class="reward-info">
            <dl v-for="(item, index) in reward_All" :key="index" :class="'reward-box-' + item.prop_id">
              <dt :class="'before-' + item.prop_id"></dt>
              <dd>{{ item.title.name }}</dd>
            </dl>
          </div>
          <div class="btn-box">
            <a href="javascript:;" @click="confirmationShow = false"></a>
            <a href="javascript:;" @click="rewardCollection()"></a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="confirmationShow = false"></div>
    </div>

    <!-- 是否添加保险箱 -->
    <div :class="'insure-popup popup_wrap insure-popup-' + insureType" v-show="insureShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="insure-box popup_wrap-box" v-show="insureShow">
          <div class="insure-info" v-html="insureInfo"></div>
          <div class="btn-box">
            <a href="javascript:;" @click="addSafe()"></a>
            <a href="javascript:;" @click="insureShow = false"></a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 渠道账户注销弹窗 -->
    <div class="popup_wrap logout-confirm-wrap" v-show="logoutPopup">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="logoutPopup">
          <div class="content">
            <p>确认注销当前用户？</p>
          </div>
          <div class="operation">
            <div @click.stop="logoutPopup = false">取消</div>
            <div @click.stop="confirmLogout()">确认</div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="logoutPopup" @click="logoutPopup = false"></div>
    </div>


    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    
  </div>

</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { Toast, Switch, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onGetInitDataAPI, buyAPI, exchangeAPI, insureAPI, insureOutAPI, rewardAPI, findAPI, shareRewardAPI, updateAPI, getTaskAPI } from '../api';
import { LogoutAPI } from '@/api/login';
import { getRandomString, buriedLogger } from '@/utils/utils';
export default {
  name: 'servitor',
  components: {
    vueSeamlessScroll,
    Login,
    Os
  },
  data () {
    return {
      gameName: 'servitor',
      icon_img: 'https://download4.qcplay.com/qcgame-admin/d5vbe60gfZ7dbtVlmLhP8kgJTCVGP23t1WNkHm1g.png',
      downloadUrl: 'https://smjh.qingcigame.com/official/',
      qqGroupsUrl: 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=25',
      shareLink: '',
      shareLinkHelp: '',
      // ios设备
      iosDevice: false,
      // 头部标题显示
      headerStatus: false,
      // 头部的好友code名称
      headMyCode: '',
      // 登录页面显示
      playShow: false,
      // 设置弹窗
      setShow: false,
      // 全屏遮罩
      preventShow: true,
      // 规则
      ruleShow: false,
      // 密令是否显示
      secretOrderShow: false,
      // 开关1
      switchStatus1: false,
      // 开关2
      switchStatus2: false,
      // 开关点击次数
      switchChickNum: 1,
      // 我的直播间
      myZbjShow: false,
      // 别人的直播间
      youZbjShow: false,
      // 卷轴购买弹窗
      buyShow: false,
      // 交易记录弹窗
      transactionShow: false,
      // 任务列表弹窗
      taskShow: false,
      // 奖励兑换弹窗
      rewardShow: false,
      // 卷轴购买弹窗
      purchaseShow: false,
      // 奖励获取完成弹窗
      rewardGainShow: false,
      // 奖励领取确认弹窗
      confirmationShow: false,
      // 奖励列表弹窗
      rewardListShow: false,
      // 保险箱弹窗
      insureShow: false,
      // 注销弹窗
      logoutPopup: false,
      // 第一次进入的提示弹窗
      firstShow: true,
      // 弹窗类型(1-2)
      insureType: 1,
      // 数量
      is_number: 1,
      is_red: false,
      // 奖励列表的等级
      rewardListGrade: 1,
      rewardGradeTab: [
        {drade: 1},{drade: 2},{drade: 3},{drade: 4},{drade: 5}
      ],
      // 留言列表
      wechatInfoList: [],
      recordList: [],
      // 任务列表
      taskList: [],
      // 星星列表
      starList: [
        {id: 1},{id: 2},{id: 3},{id: 4},{id: 5},{id: 6},{id: 7},{id: 8}
      ],
      user_data: {
        my_name: '',
        // 金币剩余数量
        species_num: 0,
        // 原产品金币
        old_pecies_num: 100,
        // 最新产品金币价格
        new_pecies_num: 0,
        code: '',
        // 魔法卷轴数量
        mf_number: ''
      },
      prop_info: {
        prop_id: '',
        title: ''
      },
      // 计算器的时间
      is_time: '',
      end_time: '',
      // 奖励集合
      reward_All: [
        { prize_pool_id:'', prop_id: '', title: {name: "", package_id: ''} },
        { prize_pool_id:'', prop_id: '', title: {name: "", package_id: ''} },
        { prize_pool_id:'', prop_id: '', title: {name: "", package_id: ''} },
        { prize_pool_id:'', prop_id: '', title: {name: "", package_id: ''} }
      ],
      picArr: [],
      // 总次数
      need_level_number: '',
      // 刷新了多少次
      up_level_number: '',
      percentage: '',
      level_info: {
        level: '',
        number: '',
        times: ''
      },
      // 是否已经领取过奖励
      is_get: '',
      // 是否可领取奖励，时间到
      start_get_reward: '',
      // 第几个角色
      roleNum: 1,
      // 分享code
      shareCode: '',
      classOption: {
        step: 0.2,
        hoverStop: false,
      },
      // 保险箱覆盖描述
      insureInfo: '',
      // 其他的的code
      otherCode: '',
      // 进入房间
      intoRoomShow: false,
      // 是否第一次
      is_first: false,
      // 第一页
      tipsNum: 1,
      newTipsNum: 1,
    };
  },
  filters: {
    taskDesc(val) {
      if(!val) {
        return '未完成'
      } else {
        return '领取'
      }
    },
    newHeadMyCode(val) {
      if(val !== '') return val + '的'
    }
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    setTimeout(() => {
      onGetInitDataAPI().then(response => {
        if (Number(response.code) == 200) {
          this.activeInfoData(response.data.activity);
          this.initShareData(response.data.user_info);
        }
        this.isWechat();
        this.preventShow = false;
        this.onInitDataCallback(response);
        this.preloadingShow = false;
      });
    }, 500);

    // 埋点
    const bl = buriedLogger('servitor', 'bbj_page');
    this.logger = bl;

    // 随机生成头像
    this.randomPic();
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.user_id) {
          this.osCancell();
          // TAG: 注销的时候
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          this.initShareData(newValue);
        }
      }
    },
    activeInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue.mf_number);
        console.log('oldValue', oldValue.mf_number);
        if (!newValue.score || !newValue.code) {
          // TAG: 注销的时候
        } else if (
          newValue.score !== oldValue.score || 
          newValue.mf_number !== oldValue.mf_number || 
          newValue.code !== oldValue.code || 
          newValue.pool_info !== oldValue.pool_info|| 
          newValue.is_get !== oldValue.is_get
        ) {
          console.log('数据变更刷新' + newValue.score)
          // TAG: 数据渲染
          this.activeInfoData(newValue);
        }
      }
    },
  },
  methods: {
    activeInfoData (info) {
      this.playShow = true;
      this.isWechat();
      // 是否第一次进入
      this.firstShow = info.is_first;
      // 金币剩余数量
      this.user_data.species_num = info.score;
      // 当前最新价格
      this.user_data.new_pecies_num = info.room_price;
      // 当前玩家code(兑换道具使用)
      this.user_data.code = info.code;
      // 魔法卷轴数量
      this.user_data.mf_number = info.mf_number;
      // 任务列表
      this.taskList = info.task_info;
      // 购买及任务完成记录
      this.recordList = info.record;
      // 滚动留言列表
      this.wechatInfoList = info.wechat_info;
      // 出现第几个动画角色带货(1-3)
      this.roleNum = info.pic_id;
      // 礼盒刷新的等级
      this.level_info = info.level_info;
      // 刷新总上线
      this.need_level_number = info.need_level_number;
      // 当前已经刷新多少次
      this.up_level_number = info.up_level_number;

      (this.up_level_number / this.need_level_number) * 100 > 100 ? this.percentage = 100 : this.percentage = (this.up_level_number / this.need_level_number) * 100;
      // 是否已经领取过奖励
      this.is_get = info.is_get;
      // 是否红点
      this.is_red = info.is_red;
      // 是否可领取奖励
      this.start_get_reward = info.start_get_reward;
      // 礼盒道具
      this.reward_All = info.pool_info;
      // 分享的code
      this.shareCode = this.toUnicode(info.code);
      this.headMyCode = info.code.substring(0, info.code.length-8);
      // 加入直播间
      this.intoRoomShow = true;
      setTimeout(() => { this.intoRoomShow = false }, 3000);
    },
    initShareData (info) {  
      const { protocol, host } = window.location;
      this.shareLink = `${protocol}//${host}/servitor/bbj/enter${getRandomString()}`;
      this.shareLinkHelp = `${protocol}//${host}/servitor/bbj/help${getRandomString()}?code=`;
      // 玩家直播间名称
      this.user_data.my_name = info.role_name + '的';
      setTimeout(() => {
        this.isSetShare('使魔计划 | 魔法播播间','我说一个数，来我播播间，福利全部带走！');
      }, 1000);
    },
    isWechat() {
      let nav_control = navigator.userAgent;
      let is_micromessenger = nav_control.toLowerCase().match(/MicroMessenger/i)=="micromessenger";
      if (nav_control.match(/(iPhone|iPod|ios)/i) && !is_micromessenger) {
        if(nav_control.toLowerCase().indexOf('qq') > -1){
          return
        }
        is_micromessenger ? this.headerStatus = false : this.headerStatus = true;
        this.iosDevice = true;
      }
    },
    randomPic() {
      while (this.picArr.length < 3) {
        var randomNum = Math.floor(Math.random() * 8) + 1;
        if (this.picArr.indexOf(randomNum) === -1) {
          this.picArr.push(randomNum);
        }
      }
    },
    // 打开直播
    openBtn() {
      // 是否登录
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this.$nextTick(() => {
        Indicator.open();
        setTimeout(() => {
          Indicator.close();
          this.playShow = true;
          onGetInitDataAPI().then(response => {
            if (Number(response.code) == 200) {
              this.activeInfoData(response.data.activity);
              this.initShareData(response.data.user_info);
            }
            this.onInitDataCallback(response);
            this.preloadingShow = false;
          });
        }, 1000);
      });      
    },    
    // 选择角色后
    selectCallback () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.osCancell();
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {
      // 关闭
      this.playShow = false;
      this.headerStatus = false;
      this.otherCode = '';    
    },
    // TAG: 相关业务方法
    onInvite () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    switchStatus(data, num, info, control) {
      if(data) {
        this.preventShow = true;
        Indicator.open();
        setTimeout(()=> {
          Indicator.close();
          if(num == 1) {
            this.onToast(info);
          } else {
            if(this.switchChickNum == 1) {
              this.switchChickNum = this.switchChickNum + 1;
              this.onToast(info);
            } else {
              this.onToast('这次真没了，别点了...');
            }
            this.secretOrderShow = true;
          }
          this.switchStatus1 = false;
          this.switchStatus2 = false;        
          this.preventShow = false;
          this.logger.sum('使魔魔法播播间H5活动_点击设置中'+ control +'的switch次数');
        }, 2000)
      }
    },
    // 查找播播间
    viewFriendsRoom() {
      this.youZbjShow = true;
      this.logger.sum('使魔魔法播播间H5活动_点击查找直播间按钮次数');
    },
    // 分享直播间
    viewShareRoom() {
      this.myZbjShow = true;
      this.logger.sum('使魔魔法播播间H5活动_点击分享直播间按钮次数');
    },
    // 查看记录 
    viewRecords() {
      Indicator.open();
      setTimeout(()=> {
        this.transactionShow = true;
        Indicator.close();
        this.logger.sum('使魔魔法播播间H5活动_点击交易次数按钮次数');
      }, 500);
    },
    // 开启任务
    viewTask() {
      Indicator.open();
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.taskShow = true;        
        this.logger.sum('使魔魔法播播间H5活动_点击赚取金币按钮次数');
        Indicator.close();
      });
    },
    // 点击礼盒按钮
    viewReward() {
      this.rewardShow = true;
      this.logger.sum('使魔魔法播播间H5活动_点击礼盒按钮次数');
    },
    // 打开购买按钮
    openBuyBtn() {
      var user_data = this.user_data;
      var floor_num = Math.floor(user_data.species_num / user_data.new_pecies_num);
      floor_num < 1 ? this.is_number = floor_num : this.is_number = 1;
      this.buyShow = true;
    },
    // 减少
    reduce() {
      const num = this.is_number;
      if(num > 1) {
        this.is_number = num - 1
      }      
    },
    // 增加
    add() {
      const user_data = this.user_data;
      let num = this.is_number;
      if (this.is_number < Math.floor(user_data.species_num / user_data.new_pecies_num)) {
        this.is_number = num + 1
      }
    },
    // 点击最大按钮
    maxCount() {
      var user_data = this.user_data;
      this.is_number = Math.floor(user_data.species_num / user_data.new_pecies_num);      
    },
    // 关闭购买弹窗
    closeBuy() {
      this.is_number = 1;
      this.buyShow = false;
    },
    // 前往购买
    goBuy() {
      Indicator.open();
      this.preventShow = true;
      buyAPI({number: this.is_number, code: ''}).then(response => {
        setTimeout(()=> {
          if (Number(response.code) == 200) {
            this.purchaseShow = true;
            this.buyShow = false;
            onGetInitDataAPI().then(response => {
              this.onInitDataCallback(response);
            });
            this.logger.sum('使魔魔法播播间H5活动_购买魔法卷轴');
          }
          if (Number(response.code) !== 200) {
            Toast({ message: response.message, duration: 1000, className: 'toasts' });
          }
          this.preventShow = false;
          Indicator.close();
        }, 1000);
      });
    },
    refreshAni(num) {
      var _this = this;
      _this.is_time = 4000;
      function settime(){
        if(_this.is_time==0){
          _this.is_time=50;
          clearTimeout(_this.end_time);
        }else{
          _this.is_time--;
          _this.reward_All[num].title.name = '抽奖中...';
          _this.reward_All[num].prop_id = Math.floor(Math.random()*44)+1;
          _this.end_time = setTimeout(function(){
            settime()
          },80)
        }
      }settime()
    },
    // 刷新奖励(1-3)
    refreshRewards(num) {
      Indicator.open();
      this.preventShow = true;
      exchangeAPI({prize_pool_id: num}).then(response => {
        if (Number(response.code) == 200) {
          this.refreshAni(Number(num-1));
          this.$nextTick(() => {
            setTimeout(()=> {
              clearTimeout(this.end_time);
              let _data = response.data;
              // 是否已经领取过奖励
              this.is_get = _data.activity.is_get;
              // 相关等级信息
              this.level_info = _data.activity.level_info;
              // 刷新总上线
              this.need_level_number = _data.activity.need_level_number;
              // 当前已经刷新多少次
              this.up_level_number = _data.activity.up_level_number;
              // 是否可领取奖励
              this.start_get_reward = _data.activity.start_get_reward
              // 礼盒道具
              this.reward_All = _data.activity.pool_info;

              (this.up_level_number / this.need_level_number) * 100 > 100 ? this.percentage = 100 : this.percentage = (this.up_level_number / this.need_level_number) * 100;
              // 4个相关道具的位置
              this.prop_info = _data.prop_info;
              this.rewardGainShow = true;
              this.preventShow = false;
              Indicator.close();
              this.logger.sum('使魔魔法播播间H5活动_刷新使魔奖池');
            }, 1000);
          }); 
        }
        if (Number(response.code) !== 200) {
          setTimeout(()=> {
            Toast({ message: response.message, duration: 1000, className: 'toasts' });
            this.preventShow = false;
            Indicator.close();
          }, 1000);
        }        
      });
    },
    // 关闭抽奖弹窗初始化
    rewardClose() {
      Indicator.open();
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.rewardShow = false;
        Indicator.close();
      });
    },
    // 是否保存
    saveOrNot(type) {
      if(this.is_get !== 0) {
        Toast({ message: '您已经领取过奖励,无需进行该项操作！', duration: 3000, className: 'toasts' });
        return
      }
      let firstName =  this.reward_All[0].title.name;
      let lastName = this.reward_All[3].title.name;
      this.insureType = type;
      // 保存到保险箱
      if(type == 1) {
        if(firstName.length !== 0) {
          this.insureShow = true;
          // 保险箱存储
          lastName == undefined || lastName == '' ? 
            this.insureInfo = '是否将奖池奖励<strong>'+ firstName + '</strong>替换至<strong>空保险箱</strong>中？' :
            this.insureInfo = '是否将奖池奖励<strong>'+ firstName + '</strong>替换至保险箱的<strong>' + lastName +  '</strong>奖励？';
        } else {
          Toast({ message: '非常抱歉,暂时没有奖励可添加存储保险箱', duration: 1000, className: 'toasts' });
        }
      } else {
        // 保险箱中提取
        if(lastName.length !== 0) {
          this.insureShow = true;
          // 保险箱存储
          this.insureInfo = '是否将保险箱中的<strong>'+ lastName + '</strong>提取,覆盖替换当前奖励？';
        } else {
          Toast({ message: '非常抱歉,暂时没有奖励可提取', duration: 1000, className: 'toasts' });
        }
      }
    },
    // (加入 && 提取)保险箱
    addSafe() {
      Indicator.open();
      this.preventShow = true;
      if(this.insureType == 1) {
        // 存储到保险箱
        insureAPI().then(response => {
          setTimeout(()=> {
            if (Number(response.code) == 200) {
              onGetInitDataAPI().then(response => {
                this.onInitDataCallback(response);
              });
            }
            this.logger.sum('使魔魔法播播间H5活动_玩家加入保险箱');
            Toast({ message: response.message, duration: 1000, className: 'toasts' });
            this.insureShow = false;
            this.preventShow = false;
            Indicator.close();
          }, 2000);
        });
      } else {
        // 提取出保险箱
        insureOutAPI().then(response => {
          setTimeout(()=> {
            if (Number(response.code) == 200) {
              onGetInitDataAPI().then(response => {
                this.onInitDataCallback(response);
              });
            }
            this.logger.sum('使魔魔法播播间H5活动_玩家取出保险箱');
            Toast({ message: response.message, duration: 1000, className: 'toasts' });
            this.insureShow = false;
            this.preventShow = false;
            Indicator.close();
          }, 2000);
        });
      }      
    },
    // 确认是否能领取最终奖励
    confirmReward() {
      if(this.is_get == 0) {
        if(this.start_get_reward == true) {
          if(this.reward_All[0].prop_id == 0 && this.reward_All[3].prop_id !== 0) {
            Toast({ message: '请点击保险箱,将保险箱中的奖励提取出来进行领奖结算!', duration: 3000, className: 'toasts' });
            return
          }
          if(this.reward_All[0].prop_id == 0 && 
            this.reward_All[1].prop_id == 0 && 
            this.reward_All[2].prop_id == 0 && 
            this.reward_All[3].prop_id == 0
          ) {
            Toast({ message: '非常抱歉,您暂无奖励可领取！', duration: 3000, className: 'toasts' });
            return
          }
          this.confirmationShow = true;
          return
        }
        Toast({ message: '非常抱歉,请于4月30日领取奖励!', duration: 3000, className: 'toasts' }); 
        return
      }
      Toast({ message: '您已经领取过奖励,无需重复领奖！', duration: 3000, className: 'toasts' }); 
    },
    // 奖励领取
    rewardCollection() {
      Indicator.open();
      this.preventShow = true;
      // 奖励领取API
      rewardAPI().then(response => {
        setTimeout(()=> {
          if (Number(response.code) == 200) {
            onGetInitDataAPI().then(response => {
              this.onInitDataCallback(response);
            });
          }
          this.logger.sum('使魔魔法播播间H5活动_领取最终游戏道具奖励');
          Toast({ message: response.message, duration: 1000, className: 'toasts' });
          this.confirmationShow = false;
          this.preventShow = false;
          Indicator.close();
        }, 500);
      });
    },
    purchaseClose() {
      this.is_number = 1;
      this.purchaseShow = '';
    },
    onCopyShare(my_id) {
      this.preventShow = true;
      this.onCopy(my_id);  
      // 奖励领取API
      shareRewardAPI().then(response => {        
        if (Number(response.code) == 200) {
          setTimeout(()=> {
            this.preventShow = false;
            this.logger.sum('使魔魔法播播间H5活动_点击分享自己的播播间');
          }, 500);
        }        
      });
    },
    // 复制链接
    onCopy (my_id) {
      const clipboard = new Clipboard(my_id);
      clipboard.on('success', (e) => {
        Toast({ message: '复制成功', duration: 1000, className: 'toasts' });
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        Toast({ message: '复制失败', duration: 1000, className: 'toasts' });
      });
      this.logger.sum('使魔魔法播播间H5活动_复制密令按钮');
    },
    // 查询直播间
    findCode() {
      if( this.otherCode == '') {
        Toast({ message: '请您输入好友的直播间!', duration: 1000, className: 'toasts' });
        return
      }
      Indicator.open();
      this.preventShow = true;
      // 奖励领取API
      findAPI({code: this.otherCode}).then(response => {
        setTimeout(()=> {
          this.logger.sum('使魔魔法播播间H5活动_查询直播间code码');
          if (Number(response.code) == 200) {
            window.location.href = this.shareLinkHelp + this.toUnicode(this.otherCode);
          }
          Toast({ message: response.message, duration: 1000, className: 'toasts' });
          this.preventShow = false;
          Indicator.close();
        }, 500);
      });
    },
    confirmLogout () {
      LogoutAPI({game_id: '67'}).then((response) => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          Toast({ message: response.message, duration: 1000, className: 'toasts' });
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.setShow = false;
          this.logoutPopup = false;
        }
      });
    },
    // TODO: 登陆弹窗demo
    openLoginOS () {
      if (this.userInfo.account) {
        this.setShow = false;
        this.changeOsPopup(true);
      } else {
        this.logoutPopup = true;
      }
    },
    // 分享
    isSetShare(is_title, is_desc) {
      this.setShare({ 
        title: is_title,
        desc: is_desc,
        imgUrl: this.icon_img,
        link: this.shareLink
      });
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    toUnicode(str) {
      var res = [];
      for (var i = 0; i < str.length; i++) {
          res[i] = ( "00" + str.charCodeAt(i).toString(16) ).slice(-4);
      }
      return "/u" + res.join("/u");
      // return str.replace(/([\u4E00-\u9FA5]|[\uFE30-\uFFA0])/g,function(newStr){
      //   return "/u" + newStr.charCodeAt(0).toString(16);
      // });
    },
    tipspage() {
      this.preventShow = true;
      this.tipsNum = '';      
      setTimeout(()=> {
        this.tipsNum = this.newTipsNum + 1;
        this.newTipsNum = this.tipsNum;
        if(this.newTipsNum > 3) {
          this.firstShow = true;
          // 奖励领取API
          updateAPI().then(response => {        
            if (Number(response.code) == 200) {
              onGetInitDataAPI().then(response => {
                this.onInitDataCallback(response);
                this.tipsNum = ''; 
              });
            }
          });
        }
        setTimeout(()=> {
          this.preventShow = false;
        }, 200);
      }, 300);
    },
    // 任务领取
    taskReceive(id, name, _get) {
      if(!_get) {
        Toast({ message: '非常抱歉,您暂未完成任务，请完成任务后领取!', duration: 3000, className: 'toasts' });
        return
      }
      this.preventShow = true;
      Indicator.open();
      getTaskAPI({'task_id': id}).then(response => {
        if (Number(response.code) === 200) {
          setTimeout(()=> {
            if(response.data.result) {
              Toast({ message: '领取成功', duration: 1000, className: 'toasts' });
            }
            onGetInitDataAPI().then(response => {
              this.onInitDataCallback(response);
              this.logger.sum('使魔魔法播播间H5活动_任务列表领取'+name+'的金币奖励任务次数');
              this.preventShow = false;
              Indicator.close();
            });
          }, 500);
          return
        }
        Toast({ message: response.message, duration: 1000, className: 'toasts' });
      });
    },
    // 前往加群
    qqGroups() {
      this.preventShow = true;
      Indicator.open();
      this.logger.sum('使魔魔法播播间H5活动_前往一键加群');
      setTimeout(()=> {
        this.preventShow = false;
        Indicator.close();
        window.location.href = this.qqGroupsUrl;
      }, 500);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setActiveInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/servitor/bbj/index/index.vue